<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('search.title') }}</strong>
                </h4>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-4">
                        <label for="nameuser">{{ $t('inquiry.search.Inquiry Title') }}</label>
                        <InputText id="nameuser" type="text" :placeholder="$t('inquiry.search.Title')" v-model="title" />
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="s-state">{{ $t('inquiry.search.UserType') }}</label>
                        <Dropdown id="s-state" v-model="user_type" :options="dropdownUsers" optionLabel="name" optionValue="code" :placeholder="$t('inquiry.search.UType')"></Dropdown>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="nameuser">{{ $t('inquiry.search.Id') }}</label>
                        <InputText id="nameuser" type="text" :placeholder="$t('inquiry.search.Id')" v-model="email" />
                    </div>
                </div>
                <!-- <div class="p-formgrid p-grid p-mb-3">
                    
                    
                </div> -->
                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mt-6 p-flex-column p-flex-lg-row">
                    <div class="p-mb-4 p-mb-lg-0">
                        <!-- <Button :label="$t('button.today')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="today"></Button>
                        <Button :label="$t('button.lastWeek')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastweek"></Button>
                        <Button :label="$t('button.lastMonth')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastmonth"></Button>
                        <Button :label="$t('button.last6Months')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastsixmonth"></Button> -->
                        <!-- <Button :label="$t('button.lastYear')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastyear"></Button> -->
                    </div>
                    <div>
                        <Button :label="$t('button.search')" icon="pi pi-search" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="SearchInquiry"></Button>
                        <Button :label="$t('button.reset')" icon="pi pi-replay" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="ResetInquiry"></Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="card">
                <h5>{{ $t('inquiry.list.Inquiry List') }}</h5>
                <div class="p-d-flex p-jc-between p-mb-2">
                    <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mb-2 p-flex-column p-flex-lg-row">
                        <!-- <div>
                        
                    </div> -->
                        <div class="p-mb-4 p-mb-lg-0 page">
                            <label for="order"
                                >{{ $t('inquiry.list.Record') }}: {{ pagination.total_records }}
                                <Dropdown class="p-ml-2" id="order" v-model="pagination.pagination_limit" :options="pagination_limit_options" optionLabel="label" optionValue="value" placeholder="10개씩 보기" />
                            </label>
                        </div>
                        <!-- <router-link :to="'/AdminManagement/AddAdmin'">
                        <Button label="Primary" class="p-mr-2 p-mb-2">{{ $t('Admin.list.AddNew') }}</Button>
                    </router-link> -->
                    </div>
                    <!-- <div>
                        <h5>{{ $t('inquiry.list.Inquiry List') }}</h5>
                    </div> -->
                    <div>
                        <!-- <Button label="Primary" class="p-mr-2 p-mb-2" @click="openBasic"><i class="pi pi-download p-mr-2"></i>{{ $t('button.downloadExcel') }}</Button> -->
                    </div>
                    <!-- <Dialog header="Please enter reason for download this file" v-model:visible="displayBasic" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '25vw' }">
                        <h5 style="margin-top: 10px">Enter Reason</h5>
                        <Textarea v-model="downloadReason" rows="10" style="width: 100%" maxlength="200" @input="Whenchange" />
                        <small style="color: gray">200 character maximum.</small>
                        <template #footer>
                            <Button label="Submit" icon="pi pi-check" @click="exceldownload" :disabled="IsDisable" />
                            <Button label="Cancel" icon="pi pi-times" @click="closeBasic" autofocus />
                        </template>
                    </Dialog> -->
                </div>
                <DataTable :value="results" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty>문의를 찾을 수 없습니다</template>
                    <template #loading>어드민 정보 로딩중..</template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="slNO" :header="$t('inquiry.list.No')">
                        <template #body="{ index }">
                            <span class="p-column-title">Name</span>
                            {{ pagination.current_page * pagination.pagination_limit - pagination.pagination_limit + (index + 1) }}
                        </template>
                    </Column>
                    <Column :header="$t('inquiry.list.Title')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Inquiry Title</span>
                            <template class="p-column-title" v-if="data.title.length < 12"> {{ data.title }}</template>
                            <template class="p-column-title" v-else> {{ data.title.substring(0, 12) + '..' }}</template>
                            <!-- {{ data.title }} -->
                        </template>
                    </Column>
                    <Column :header="$t('inquiry.view.Content')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Inquiry Title</span>
                            <template class="p-column-title" v-if="data.consultation.length < 12"> {{ data.consultation }}</template>
                            <template class="p-column-title" v-else> {{ data.consultation.substring(0, 12) + '..' }}</template>
                            <!-- {{ data.consultation == null ? '---' : data.consultation }} -->
                        </template>
                    </Column>
                    <Column :header="$t('inquiry.list.UserType')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Inquiry Title</span>
                            <span v-if="data.user_type == null">---</span>
                            <span v-else>{{ data.user_type == 'job_seeker' ? 'Job Seeker' : 'Recruiter' }}</span>
                        </template>
                    </Column>
                    <Column :header="$t('inquiry.list.Email')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Inquiry Title</span>
                            {{ data.email == null ? '---' : data.email }}
                        </template>
                    </Column>
                    <Column :header="$t('inquiry.list.Date')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">inquiry Date & Time</span>
                            {{ formatDate(data.created_date) }}
                        </template>
                    </Column>
                    <Column :header="$t('inquiry.list.Phone')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Inquiry Type</span>
                            {{ data.phone_number == null ? '---' : formatPhoneNumber(data.phone_number) }}
                        </template>
                    </Column>
                    <Column :header="$t('inquiry.list.Password')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Inquiry Type</span>
                            {{ data.password == null ? '---' : data.password }}
                        </template>
                    </Column>
                    <Column :header="$t('inquiry.list.Status')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Status</span>
                            {{ data.status == 'accepted' ? '완료' : '대기' }}
                        </template>
                    </Column>

                    <Column :header="$t('inquiry.list.Action')" style="min-width: 6rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Actions</span>
                            <p style="display: none">{{ data.id }}</p>
                            <div style="display: flex">
                                <span v-if="data.status == 'pending'">
                                    <router-link :to="'/ReplyInquiry/' + data.id"
                                        ><Button label="info" class="p-button2"><i class="pi pi-reply p-mr-2"></i> </Button>
                                    </router-link>
                                </span>
                                <span v-else>
                                    <router-link :to="'/inquiry_details/' + data.id"
                                        ><Button label="info" class="p-button2"><i class="pi pi-reply p-mr-2"></i> </Button>
                                    </router-link> </span
                                >&nbsp;&nbsp;

                                <Button icon="pi pi-trash" class="p-button2" @click="confirm(data.id)" />
                            </div>
                        </template>
                    </Column>
                </DataTable>
                <div class="p-paginator p-component p-paginator-bottom">
                    <button @click="paginate(1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-first p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-double-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button @click="paginate(pagination.current_page - 1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-next p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <span class="p-paginator-pages">
                        <button
                            v-for="(page, index) in get_paginator_page(pagination.total_pages, pagination.current_page)"
                            :key="index"
                            @click="paginate(page)"
                            class="p-paginator-page p-paginator-element p-link"
                            :class="{ 'p-highlight': page === pagination.current_page }"
                            type="button"
                        >
                            {{ page }}<span class="p-ink"></span>
                        </button>
                    </span>
                    <button
                        @click="paginate(pagination.current_page + 1)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        class="p-paginator-next p-paginator-element p-link"
                        type="button"
                        :disabled="pagination.current_page === pagination.total_pages"
                    >
                        <span class="p-paginator-icon pi pi-angle-right"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button
                        @click="paginate(pagination.total_pages)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        :disabled="pagination.current_page === pagination.total_pages"
                        class="p-paginator-last p-paginator-element p-link"
                        type="button"
                    >
                        <span class="p-paginator-icon pi pi-angle-double-right"></span>
                        <span class="p-ink"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useRoute } from 'vue-router';
// import validateUsersearch from '../../validations/user/validateUserSearch';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';
import formatDate from '../../mixin/mixinFunction';
import InquiryService from '../../service/API/InquiryService';
import axios from 'axios';
import utils from '@/service/utils';
// import ProductService from '../service/ProductService';
// import axios from 'axios';
export default {
    mixins: [formatDate],
    data() {
        return {
            adminType: localStorage.getItem('admin-type'),
            inqTitle: '',
            inqtypes: [],
            inqType: '',
            contenttypes: '',
            inqId: '',
            nickName: '',
            status: '',
            start_date: '',
            end_date: '',
            contenttype: '',
            selected: [],
            selectedItemss: '',
            render: true,
            display: false,
            position: 'center',
            loading1: true,
            expandedRows: [],
            user: null,
            statuses: ['unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'],
            operations: [{ name: 'delete', code: 'delete' }],
            operation: null,
            replayOptions: [
                { name: 'Answered', code: 'answered' },
                { name: 'Not Answered', code: 'not_answered' },
            ],
            state: '',
            content: '',
            dropdownItem: null,
            error: {},
            results: [],
            pagination_limit_options: [
                { label: '10개씩 보기', value: 10 },
                { label: '20개씩 보기', value: 20 },
                { label: '50개씩 보기', value: 50 },
                { label: '100개씩 보기', value: 100 },
            ],
            pagination: {
                current_page: 1,
                pagination_limit: 10,
                total_pages: 0,
                total_records: 0,
            },
            totalrecords: '',
            result: '',
            dropdownUsers: [
                { name: '구직자', code: 'job_seeker' },
                { name: '구인자', code: 'job_recruiter' },
            ],
            dropdownUser: null,
            user_type: '',
            user_id: '',
            title: '',
            unique_id: '',
        };
    },
    customerService: null,
    productService: null,
    created() {
        this.inquiryService = new InquiryService();
        // this.title = localStorage.getItem('title')
        // this.user_type = localStorage.getItem('user_type')
        // this.email = localStorage.getItem('email')
        // const params = {
        //     title: this.title,
        //     user_type: this.user_type,
        //     email: this.email,
        // };
        // this.callAPI(params);
    },
    mounted() {
        const route = useRoute();
        console.log(route.params);
        // this.getNQlist();
        // this.inquiryService.getInquiryType().then((data) => {
        //     console.log(data);
        //     this.inqtypes = data;
        // });
        // if (this.adminType == 'admin') {
        //     this.filterRender = true;
        // } else {
        //     this.filterRender = false;
        // }
        this.storageData = localStorage.getItem('InquiryManagement') ? JSON.parse(localStorage.getItem('InquiryManagement')) : '';

        if (this.storageData != '') {
            this.InquiryPagination = this.storageData.current_page;
            this.title = this.storageData.title == undefined ? '' : this.storageData.title;
            this.user_type = this.storageData.user_type == undefined ? '' : this.storageData.user_type;
            this.email = this.storageData.email == undefined ? '' : this.storageData.email;

            // let FromDate = this.storageData.created_date ? new Date(this.storageData.created_date) : '';
            // this.created_date = FromDate;
        }
        if (this.InquiryPagination == '' || this.InquiryPagination == null) {
            if (this.title || this.email || this.user_type) {
                const searchLocalParams = {
                    page: this.pagination.current_page,
                    limit: this.pagination.pagination_limit,
                    title: this.storageData.title == undefined ? '' : this.storageData.title,
                    user_type: this.storageData.user_type == undefined ? '' : this.storageData.user_type,
                    email: this.storageData.email == undefined ? '' : this.storageData.email,
                    // created_date: this.storageData.created_date == undefined ? '' : this.storageData.created_date,
                };
                this.getNQlist(searchLocalParams);
            } else {
                this.getNQlist({ limit: this.pagination.pagination_limit, page: this.pagination.current_page });
            }
        } else {
            const searchLocalParams = {
                page: this.InquiryPagination,
                limit: this.pagination.pagination_limit,
                title: this.storageData.title == undefined ? '' : this.storageData.title,
                user_type: this.storageData.user_type == undefined ? '' : this.storageData.user_type,
                email: this.storageData.email == undefined ? '' : this.storageData.email,
            };
            this.getNQlist(searchLocalParams);
        }
    },
    watch: {
        'pagination.pagination_limit'(val) {
            this.getNQlist({ limit: val, page: 1 });
        },
    },
    methods: {
        Whenchange() {
            if (this.downloadReason != '') {
                this.IsDisable = false;
            } else {
                this.IsDisable = true;
            }
        },
        openBasic() {
            this.displayBasic = true;
        },
        closeBasic() {
            this.displayBasic = false;
        },
        // callAPI(val) {
        //     this.inquiryService
        //         .getInquiryList(val)
        //         .then((res) => {
        //             this.results = res.data.result;
        //             this.totalrecords = res.data.total_records;
        //             this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
        //             this.loading1 = false;
        //             // console.log(res);
        //         })
        //         .catch((err) => console.log(err));
        // },
        getNQlist(data) {
            // const InquirylistParams = {
            //     page: 1,
            //     limit: this.pagination.pagination_limit,
            //     // title: this.title,
            //     // // create_date: this.create_date,
            //     // job_type: this.job_type,
            //     // user_id: this.user_id
            // };
            this.loading1 = true;
            // this.callAPI(InquirylistParams);
            this.inquiryService
                .getInquiryList(data)
                .then((res) => {
                    this.results = res.data.result;
                    this.totalrecords = res.data.total_records;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    console.log(res);
                })
                .catch((err) => console.log(err));
        },
        setPagination(current_page, total_pages, total_records) {
            this.pagination.current_page = current_page;
            this.pagination.total_pages = total_pages;
            this.pagination.total_records = total_records;
        },
        get_paginator_page(total, active) {
            return utils.paginate(total, active);
        },

        paginate(page) {
            this.loading1 = true;
            localStorage.setItem(
                'InquiryManagement',
                JSON.stringify({
                    current_page: page,
                    // limit: this.pagination.pagination_limit,
                    title: this.title,
                    user_type: this.user_type,
                    email: this.email,
                })
            );
            this.inquiryService
                .getInquiryList({
                    page: page,
                    limit: this.pagination.pagination_limit,
                    title: this.title,
                    user_type: this.user_type,
                    email: this.email,
                })
                .then((res) => {
                    this.results = res.data.result;
                    this.pagination.current_page = page;
                    this.loading1 = false;
                    console.log(res.data);
                })
                .catch((err) => console.log(err));
        },
        resetUser() {
            (this.inqTitle = ''), (this.inqId = ''), (this.nickName = ''), (this.inqType = ''), (this.start_date = ''), (this.end_date = ''), (this.status = '');
            this.getlist();
        },
        searchuser() {
            if (this.inqTitle == '' && this.inqId == '' && this.nickName == '' && this.inqType == '' && this.start_date == '' && this.end_date == '' && this.status == '') {
                this.$toast.add({ severity: 'error', summary: 'Error message', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            } else {
                this.getlist();
            }
        },
        formatPhoneNumber(num) {
            var cleaned = ('' + num).replace(/\D/g, '');
            if (num.toString().length == '11') {
                var match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);
                if (match) {
                    return '(' + match[1] + ') ' + match[2] + ' - ' + match[3];
                }
                return null;
            } else if (num.toString().length == '10') {
                var match1 = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
                if (match1) {
                    return '(' + match1[1] + ') ' + match1[2] + ' - ' + match1[3];
                }
                return null;
            } else if (num.toString().length == '9') {
                var match2 = cleaned.match(/^(\d{1})(\d{4})(\d{4})$/);
                if (match2) {
                    return '(' + match2[1] + ') ' + match2[2] + ' - ' + match2[3];
                }
                return null;
            }
        },
        SearchInquiry() {
            if (this.title == '' && this.user_type == '' && this.email == '') {
                // console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            } else {
                // localStorage.setItem('title', this.title);
                // localStorage.setItem('user_type', this.user_type);
                // localStorage.setItem('email', this.email);
                localStorage.setItem(
                    'InquiryManagement',
                    JSON.stringify({
                        current_page: 1,
                        // limit: this.pagination.pagination_limit,
                        title: this.title,
                        user_type: this.user_type,
                        email: this.email,
                    })
                );
                let InquirySearchParams = {
                    limit: this.pagination.pagination_limit,
                    page: 1,
                    title: this.title,
                    user_type: this.user_type,
                    email: this.email,
                };
                this.loading = true;
                // this.callAPI(InquirySearchParams);

                this.inquiryService
                    .getInquiryList(InquirySearchParams)
                    .then((res) => {
                        this.results = res.data.result;
                        this.totalrecords = res.data.total_records;
                        this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                        this.loading1 = false;
                        console.log(res);
                    })
                    .catch(() => {
                        this.results = [];
                        this.loading1 = false;
                    });
            }
        },
        ResetInquiry() {
            // localStorage.setItem('title', '');
            // localStorage.setItem('email', '');
            // localStorage.setItem('user_type', '');

            this.title = '';
            this.user_type = '';
            this.email = '';
            this.pagination.pagination_limit = '';
            localStorage.setItem('InquiryManagement', '');

            this.getNQlist();
            window.location.reload();
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_date = utc;
            this.end_date = utc;
            this.getlist();
            console.log(this.start_date);
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        exceldownload() {
            this.inquiryService
                .getExcel(
                    this.inqTitle.trim(),
                    this.inqId.trim(),
                    this.nickName.trim(),
                    this.inqType.id,
                    this.start_date == '' ? '' : this.formatDate(this.start_date),
                    this.end_date == '' ? '' : this.formatDate(this.end_date),
                    this.status.code == undefined ? '' : this.status.code,
                    this.downloadReason
                )
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Inquirylist.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.closeBasic();
                });
        },
        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },

        confirm(id) {
            let self = this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'post', url: `/api/v1/admin/inquiry/delete`, data: { inquiry_id: id } }).then(function (response) {
                        console.log(response);
                    });
                    this.getNQlist();
                    self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}

.p-fluid {
    .p-button {
        width: auto;
    }
}

.p-button {
    background: white;
    // border: 1px solid #0A0A0A;
    color: black;
}
</style>
